// DEPENDENCIES
import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import { useFormik } from "formik";
import _ from 'lodash';
// COMPONENTS
import { Link } from "react-router-dom";
import SVG from "react-inlinesvg";
import Select from 'react-select';
import InputMask from "react-input-mask";
import { Form, ListGroup } from "react-bootstrap";
import { ModalProgressBar } from "../../../_metronic/_partials/controls";
// CUSTOM COMPONENTS
import * as alert from "../../../redux/alertSnackBarRedux";
import * as confirmModal from "../../../redux/confirmModalRedux";
// SERVICES AND HELPERS
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import * as locationService from "../../../services/management/locationService";
import * as credentialService from "../../../services/training/credentialService";
import * as trainingTypeService from "../../../services/companyData/trainingTypeService";
import * as trainingSubTypeService from "../../../services/companyData/trainingSubTypeService";
import ClientLocationValidator from "../../../helpers/validators/ClientLocationValidator";
import { getInputClasses, setToOptionModel } from "../../../helpers/helper";

const ClientLocationDetail = (props) => {
    const { showAlert, clientProfile } = props;
    const [loading, setloading] = useState(false);
    // const [credentialTypeList, setCredentialTypeList] = useState([]);
    // const [selectedCredentialType, setSelectedCredentialType] = useState(null);
    // const [credentialSubTypeList, setCredentialSubTypeList] = useState([]);
    // const [selectedCredentialSubType, setSelectedCredentialSubType] = useState(null);
    // const [credentialList, setCredentialList] = useState([]);
    // const [selectedCredential, setSelectedCredential] = useState(null);
    const [locationCredentials, setLocationCredentials] = useState([]);
    const [clientLocationModel, setClientLocationModel] = useState({
        id: 0,
        clientId: clientProfile.id,
        businessName: '',
        contactName: '',
        contactPhone: '',
        contactEmail: '',
        additionalEmails: '',
        accountingName: '',
        accountingPhone: '',
        accountingEmail: '',
        description: '',
        address1: '',
        address2: '',
        isPrimary: false,
        billingAddress: "",
        city: '',
        state: '',
        zipCode: '',
        locationCredentials: []
    });
    let locationId = props.match.params.id;

    useEffect(() => {
        // fetchTrainingType();
        if (locationId != 0) {
            locationService.getLocationById(locationId).then(res => {
                var submissionModel = _.pick(res, ["id", "clientId", "businessName", "contactName", "contactPhone", "contactEmail", "accountingName", "additionalEmails", "accountingPhone", "accountingEmail", "description", "isPrimary", "billingAddress"]);
                submissionModel.address1 = res.address.address1;
                submissionModel.address2 = res.address.address2;
                submissionModel.city = res.address.city;
                submissionModel.state = res.address.state;
                submissionModel.zipCode = res.address.zipCode;
                setClientLocationModel(submissionModel);
                // if (res.locationCredentials) {
                //     populateSavedCredential(res.locationCredentials)
                // }
            })
        } else {
        }
    }, []);

    // const populateSavedCredential = (credentials) => {
    //     credentialService.getCredentials(false).then(res => {
    //         let saveLocationCredentials = credentials.map(credential => {
    //             let savedCredential = res.find(x => x.id == credential.credentialId);

    //             return {
    //                 id: credential.credentialId,
    //                 name: savedCredential.trainingType + ' - ' + (savedCredential.trainingSubType ? savedCredential.trainingSubType : "No SubType") + ' - ' + savedCredential.name
    //             };
    //         })
    //         setLocationCredentials(saveLocationCredentials);
    //     });

    // }

    // const fetchTrainingType = () => {
    //     return trainingTypeService.getTrainingTypes(false).then(res => {
    //         let options = res.map(x => setToOptionModel(x.name, x.id));
    //         setCredentialTypeList(options);

    //         return options;
    //     }).catch(ex => showAlert({ message: ex.message, variant: 'error' }));
    // }

    // const fetchTrainingSubType = (trainingTypeId) => {
    //     return trainingSubTypeService.getTrainingSubTypes(trainingTypeId, false).then(res => {
    //         let options = res.map(x => setToOptionModel(x.name, x.id));
    //         options.push(setToOptionModel("No SubType", 0));
    //         setCredentialSubTypeList(options);

    //         return options;
    //     })
    // }

    // const fetchCredential = (typeId, subTypeId) => {
    //     return credentialService.getCredentialsByTypeAndSubType(typeId, subTypeId).then(res => {
    //         var options = res.map(x => setToOptionModel(x.name, x.id));
    //         setCredentialList(options);

    //         return options;
    //     })
    // }

    // const addCredential = () => {
    //     let allLocationCredentials = [...locationCredentials];
    //     selectedCredential.forEach(credential => {
    //         if (!locationCredentials.map(x => x.id).includes(credential.value)) {
    //             allLocationCredentials.push({
    //                 id: credential.value,
    //                 name: selectedCredentialType.label + ' - ' + selectedCredentialSubType.label + ' - ' + credential.label
    //             });
    //         }
    //     });

    //     setLocationCredentials(allLocationCredentials);
    //     emptyDropDowns();
    // }

    // const removeCredential = (index) => {
    //     let allLocationCredentials = [...locationCredentials];
    //     allLocationCredentials.splice(index, 1);

    //     setLocationCredentials(allLocationCredentials);
    // }

    // const emptyDropDowns = () => {
    //     setSelectedCredential(null);
    //     setSelectedCredentialType(null);
    //     setSelectedCredentialSubType(null);
    //     setCredentialSubTypeList([]);
    //     setCredentialList([]);
    // }

    // const handleCredentialTypeChange = (val) => {
    //     setSelectedCredentialSubType(null);
    //     setSelectedCredential(null);
    //     setSelectedCredentialType(val);
    //     fetchTrainingSubType(val.value);
    // }

    // const handleCredentialSubTypeChange = (val) => {
    //     setSelectedCredential(null);
    //     setSelectedCredentialSubType(val);
    //     fetchCredential(selectedCredentialType.value, val.value);
    // }

    const saveLocation = (values, setStatus, setSubmitting) => {
        setloading(true);
        var submissionModel = _.pick(values, ["id", "clientId", "businessName", "contactName", "additionalEmails", "contactPhone", "contactEmail", "accountingName", "accountingPhone", "accountingEmail", "description", "isPrimary", "billingAddress"]);
        submissionModel.address = _.pick(values, ["address1", "address2", "city", "state", "zipCode"]);
        // submissionModel.locationCredentials = locationCredentials.map(x => { return { locationId: submissionModel.id, credentialId: x.id } })

        locationService.saveLocation(submissionModel).then(res => {
            props.history.push("/management/client-detail/locations/" + clientProfile.id);
            showAlert({ message: res.message, variant: "success" });
        }).catch(err => {
            showAlert({ message: err.message, variant: "error" });
            setloading(false);
            setSubmitting(false)
        })
    }

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: clientLocationModel,
        validationSchema: ClientLocationValidator,
        onSubmit: (values, { setStatus, setSubmitting }) => {
            saveLocation(values, setStatus, setSubmitting);
        }
    });

    return (
        <form
            className="card card-custom card-stretch"
            onSubmit={formik.handleSubmit}
        >
            {loading && <ModalProgressBar />}
            <div className="card-header py-3">
                <div className="card-title align-items-start flex-column">
                    <h3 className="card-label font-weight-bolder text-dark">
                        {locationId == 0 ? "Add" : "Update"} Location
                    </h3>
                </div>
                <div className="card-toolbar">
                    <button
                        type="submit"
                        className={`btn btn-success mr-2`}
                        disabled={
                            formik.isSubmitting || (formik.touched && !formik.isValid)
                        }
                    >
                        Save Location
                        {formik.isSubmitting}
                    </button>
                    <Link
                        to={"/management/client-detail/locations/" + clientProfile.id}
                        className="btn btn-danger"
                    >
                        Cancel
                    </Link>
                </div>
            </div>
            <div className="form">
                <div className="card-body">
                    <div className="row">
                        <label className="col-xl-3"></label>
                        <div className="col-lg-9 col-xl-6">
                            <h5 className="mt-lg-10 mb-6 fz-md fw-700 c-primary">Business/Contact Info</h5>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                            Business Name
                        </label>
                        <div className="col-lg-9 col-xl-6">
                            <input
                                type="text"
                                placeholder="XYZ Company"
                                className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "businessName")}`}
                                name="businessName"
                                {...formik.getFieldProps("businessName")}
                            />
                            {formik.touched.businessName && formik.errors.businessName ? (
                                <div businessName="invalid-feedback">
                                    {formik.errors.businessName}
                                </div>
                            ) : null}
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                            Contact Person
                        </label>
                        <div className="col-lg-9 col-xl-6">
                            <input
                                type="text"
                                placeholder="John Doe"
                                className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "contactName")}`}
                                name="contactName"
                                {...formik.getFieldProps("contactName")}
                            />
                            {formik.touched.contactName && formik.errors.contactName ? (
                                <div className="invalid-feedback">
                                    {formik.errors.contactName}
                                </div>
                            ) : null}
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                            Contact Email
                        </label>
                        <div className="col-lg-9 col-xl-6">
                            <div className="input-group input-group-lg input-group-solid">
                                <div className="input-group-prepend">
                                    <span className="input-group-text">
                                        <span className="svg-icon menu-icon"> <SVG src={toAbsoluteUrl("/media/svg/icons/Communication/Mail-at.svg")} /> </span>
                                    </span>
                                </div>
                                <input
                                    type="email"
                                    placeholder="john.doe@aes.net"
                                    className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "contactEmail")}`}
                                    name="email"
                                    {...formik.getFieldProps("contactEmail")}
                                />
                            </div>
                            {formik.touched.contactEmail && formik.errors.contactEmail ? (
                                <div className="invalid-feedback display-block">
                                    {formik.errors.contactEmail}
                                </div>
                            ) : null}
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                            Additional Emails
                        </label>
                        <div className="col-lg-9 col-xl-6">
                            <div className="input-group input-group-lg input-group-solid">
                                <Form.Control
                                    as="textarea"
                                    rows="2"
                                    type="additionalEmails"
                                    placeholder="Enter Additional Emails"
                                    className={`form-control form-control-lg form-control-solid`}
                                    name="additionalEmails"
                                    {...formik.getFieldProps("additionalEmails")}
                                />
                            </div>
                            <span className="form-text text-muted">Email addresses must be separated with commas</span>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                            Contact Phone
                        </label>
                        <div className="col-lg-9 col-xl-6">
                            <div className="input-group input-group-lg input-group-solid">
                                <div className="input-group-prepend">
                                    <span className="input-group-text">
                                        <span className="svg-icon menu-icon"> <SVG src={toAbsoluteUrl("/media/svg/icons/Communication/Adress-book1.svg")} /> </span>                                    </span>
                                </div>
                                <InputMask
                                    mask="(999) 999-9999"
                                    type="text"
                                    placeholder="(225)-000-0000"
                                    className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "contactPhone")}`}
                                    name="contactPhone"
                                    {...formik.getFieldProps("contactPhone")}
                                />
                            </div>
                            {formik.touched.contactPhone && formik.errors.contactPhone ? (
                                <div className="invalid-feedback display-block">
                                    {formik.errors.contactPhone}
                                </div>
                            ) : null}
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                            Description
                        </label>
                        <div className="col-lg-6 col-xl-6">
                            <div className="input-group input-group-lg input-group-solid">
                                <Form.Control as="textarea" rows="5"
                                    placeholder="Start typing..."
                                    className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "description")}`}
                                    name="description"
                                    {...formik.getFieldProps("description")}
                                />
                            </div>
                            {formik.touched.description && formik.errors.description ? (
                                <div className="invalid-feedback display-block">
                                    {formik.errors.description}
                                </div>
                            ) : null}
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                            Is Primary?
                        </label>
                        <div className="col-lg-6 col-xl-6">
                            <div className="checkbox-list mt-lg-4">
                                <label className="checkbox checkbox-primary">
                                    <input
                                        checked={formik.values.isPrimary}
                                        type="checkbox"
                                        name="sendToClient"
                                        {...formik.getFieldProps("isPrimary")}
                                    />
                                    <span></span>
                                </label>
                            </div>
                            {formik.touched.isPrimary && formik.errors.isPrimary ? (
                                <div className="invalid-feedback display-block">
                                    {formik.errors.isPrimary}
                                </div>
                            ) : null}
                        </div>
                    </div>
                    <div className="row">
                        <label className="col-xl-3"></label>
                        <div className="col-lg-9 col-xl-6">
                            <h5 className="mt-lg-10 mb-6 fz-md fw-700 c-primary">Accounting Representative Info</h5>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                            Accounting Person
                        </label>
                        <div className="col-lg-9 col-xl-6">
                            <input
                                type="text"
                                placeholder="Jane Doe"
                                className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "accountingName")}`}
                                name="accountingName"
                                {...formik.getFieldProps("accountingName")}
                            />
                            {formik.touched.accountingName && formik.errors.accountingName ? (
                                <div className="invalid-feedback">
                                    {formik.errors.accountingName}
                                </div>
                            ) : null}
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                            Accounting Email
                        </label>
                        <div className="col-lg-9 col-xl-6">
                            <div className="input-group input-group-lg input-group-solid">
                                <div className="input-group-prepend">
                                    <span className="input-group-text">
                                        <span className="svg-icon menu-icon"> <SVG src={toAbsoluteUrl("/media/svg/icons/Communication/Mail-at.svg")} /> </span>
                                    </span>
                                </div>
                                <input
                                    type="email"
                                    placeholder="jane.doe@aes.net"
                                    className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "accountingEmail")}`}
                                    name="email"
                                    {...formik.getFieldProps("accountingEmail")}
                                />
                            </div>
                            {formik.touched.accountingEmail && formik.errors.accountingEmail ? (
                                <div className="invalid-feedback display-block">
                                    {formik.errors.accountingEmail}
                                </div>
                            ) : null}
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                            Accounting Phone
                        </label>
                        <div className="col-lg-9 col-xl-6">
                            <div className="input-group input-group-lg input-group-solid">
                                <div className="input-group-prepend">
                                    <span className="input-group-text">
                                        <span className="svg-icon menu-icon"> <SVG src={toAbsoluteUrl("/media/svg/icons/Communication/Adress-book1.svg")} /> </span>                                    </span>
                                </div>
                                <InputMask
                                    mask="(999) 999-9999"
                                    type="text"
                                    placeholder="(225)-000-0000"
                                    className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "accountingPhone")}`}
                                    name="accountingPhone"
                                    {...formik.getFieldProps("accountingPhone")}
                                />
                            </div>
                            {formik.touched.accountingPhone && formik.errors.accountingPhone ? (
                                <div className="invalid-feedback display-block">
                                    {formik.errors.accountingPhone}
                                </div>
                            ) : null}
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                            Billing Address
                        </label>
                        <div className="col-lg-6 col-xl-6">
                            <div className="input-group input-group-lg input-group-solid">
                                <Form.Control as="textarea" rows="2"
                                    placeholder="Eg: 11862 Cloverland Ct, Baton Rouge, LA 70809"
                                    className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "billingAddress")}`}
                                    name="description"
                                    {...formik.getFieldProps("billingAddress")}
                                />
                            </div>
                            {formik.touched.billingAddress && formik.errors.billingAddress ? (
                                <div className="invalid-feedback display-block">
                                    {formik.errors.billingAddress}
                                </div>
                            ) : null}
                        </div>
                    </div>
                    <div className="row">
                        <label className="col-xl-3"></label>
                        <div className="col-lg-9 col-xl-6">
                            <h5 className="mt-lg-10 mb-6 fz-md fw-700 c-primary">Address Info</h5>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                            Address 1*
                        </label>
                        <div className="col-lg-9 col-xl-6">
                            <div className="input-group input-group-lg input-group-solid">
                                <div className="input-group-prepend">
                                    <span className="input-group-text">
                                        <i className="fa fa-home"></i>
                                    </span>
                                </div>
                                <input
                                    type="text"
                                    placeholder="123 Second St."
                                    className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "address1")}`}
                                    name="address1"
                                    {...formik.getFieldProps("address1")}
                                />
                            </div>
                            {formik.touched.address1 && formik.errors.address1 ? (
                                <div className="invalid-feedback display-block">
                                    {formik.errors.address1}
                                </div>
                            ) : null}
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                            Address 2
                        </label>
                        <div className="col-lg-9 col-xl-6">
                            <div className="input-group input-group-lg input-group-solid">
                                <div className="input-group-prepend">
                                    <span className="input-group-text">
                                        <i className="fa fa-building"></i>
                                    </span>
                                </div>
                                <input
                                    type="text"
                                    placeholder="Apt# 1"
                                    className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "address2")}`}
                                    name="address2"
                                    {...formik.getFieldProps("address2")}
                                />
                            </div>
                            {formik.touched.address2 && formik.errors.address2 ? (
                                <div className="invalid-feedback display-block">
                                    {formik.errors.address2}
                                </div>
                            ) : null}
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                            City*
                        </label>
                        <div className="col-lg-9 col-xl-6">
                            <div className="input-group input-group-lg input-group-solid">
                                <div className="input-group-prepend">
                                    <span className="input-group-text">
                                        <i className="fa fa-city"></i>
                                    </span>
                                </div>
                                <input
                                    type="text"
                                    placeholder="Baton Rouge"
                                    className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "city")}`}
                                    name="city"
                                    {...formik.getFieldProps("city")}
                                />
                            </div>
                            {formik.touched.city && formik.errors.city ? (
                                <div className="invalid-feedback display-block">
                                    {formik.errors.city}
                                </div>
                            ) : null}
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                            State*
                        </label>
                        <div className="col-lg-9 col-xl-6">
                            <div className="input-group input-group-lg input-group-solid">
                                <div className="input-group-prepend">
                                    <span className="input-group-text">
                                        <i className="fa fa-flag-usa"></i>
                                    </span>
                                </div>
                                <input
                                    type="text"
                                    placeholder="Louisiana"
                                    className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "state")}`}
                                    name="state"
                                    {...formik.getFieldProps("state")}
                                />
                            </div>
                            {formik.touched.state && formik.errors.state ? (
                                <div className="invalid-feedback display-block">
                                    {formik.errors.state}
                                </div>
                            ) : null}
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                            Zip Code*
                        </label>
                        <div className="col-lg-9 col-xl-6">
                            <div className="input-group input-group-lg input-group-solid">
                                <div className="input-group-prepend">
                                    <span className="input-group-text">
                                        <i className="fa fa-location-arrow"></i>
                                    </span>
                                </div>
                                <input
                                    type="text"
                                    placeholder="70809"
                                    className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "zipCode")}`}
                                    name="zipCode"
                                    {...formik.getFieldProps("zipCode")}
                                />
                            </div>
                            {formik.touched.zipCode && formik.errors.zipCode ? (
                                <div className="invalid-feedback display-block">
                                    {formik.errors.zipCode}
                                </div>
                            ) : null}
                        </div>
                    </div>
                    {/* <div className="row">
                        <label className="col-xl-3"></label>
                        <div className="col-lg-9 col-xl-6">
                            <h5 className="mt-lg-10 mb-6 fz-md fw-700 c-primary">Credential Requirements</h5>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                            Credential Type
                        </label>
                        <div className="col-lg-9 col-xl-9">
                            <Select
                                value={selectedCredentialType}
                                options={credentialTypeList}
                                onChange={handleCredentialTypeChange}
                                name="trainingTypeId"
                                placeholder="Select Credential Type"
                            />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                            Credential Sub Type
                        </label>
                        <div className="col-lg-9 col-xl-9">
                            <Select
                                isDisabled={credentialSubTypeList.length == 0}
                                value={selectedCredentialSubType}
                                options={credentialSubTypeList}
                                onChange={handleCredentialSubTypeChange}
                                name="trainingTypeId"
                                placeholder="Select Credential Sub Type"
                            />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                            Credential
                        </label>
                        <div className="col-lg-9 col-xl-9">
                            <Select
                                isMulti
                                closeMenuOnSelect={false}
                                isDisabled={credentialList.length == 0}
                                value={selectedCredential}
                                options={credentialList}
                                onChange={setSelectedCredential}
                                name="trainingTypeId"
                                placeholder="Select Credential"
                            />
                        </div>
                    </div>
                    <div className="form-group row" style={{ flexDirection: 'row-reverse' }}>
                        <button onClick={addCredential} disabled={selectedCredential == null} type="button" class="btn btn-success">Add Certification</button>
                    </div>
                    <div className="form-group row">
                        <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                            Credentials
                        </label>
                        <div className="col-lg-9 col-xl-9">
                            <ListGroup>
                                {
                                    locationCredentials.length > 0 ?
                                        locationCredentials.map((x, index) =>
                                            <ListGroup.Item key={x.id} className="d-flex justify-content-between align-items-center">
                                                {x.name}
                                                <span onClick={() => removeCredential(index)} style={{ cursor: 'pointer' }} className="badge badge-danger badge-pill">
                                                    <i style={{ color: 'white' }} className="fa fa-sm fa-trash"></i>
                                                </span>
                                            </ListGroup.Item>
                                        ) :
                                        <p>No Credentials Requirement for this location</p>
                                }

                            </ListGroup>
                        </div>
                    </div> */}
                </div>
            </div>
        </form>
    )
}

const mapStateToProps = (state) => ({
    clientProfile: state.clientProfile
})

export default connect(mapStateToProps, { ...alert.actions, ...confirmModal.actions })(ClientLocationDetail)